module.exports = __webpack_public_path__ + "c2998b71a52d9144e3463be0eb9f5516.png";